const REMITTANCE_TAB = 'remittance';

/** Read a CML remittance deep link without treating other tabs' query params as ours. */
export const readRemittanceDeepLink = (search = '') => {
  const params = new URLSearchParams(search);
  if (params.get('tab') !== REMITTANCE_TAB) {
    return { active: false, runId: null };
  }

  const runId = params.get('runId')?.trim();
  return { active: true, runId: runId || null };
};

/** Build a shareable URL while preserving unrelated query parameters on the current app URL. */
export const buildRemittanceRunLink = (href, runId) => {
  const url = new URL(href);
  url.searchParams.set('tab', REMITTANCE_TAB);
  url.searchParams.set('runId', String(runId));
  return url.toString();
};
